// services/maintenanceService.ts
import { supabase } from "../lib/supabaseClient";
import { logAndThrow } from "../utils/logging";
import {
  MAINTENANCE_QUERY_KEY,
  normalizeMaintenanceStatus,
  type MaintenanceScope,
  type MaintenanceStatus,
} from "../utils/maintenance";

export { MAINTENANCE_QUERY_KEY };

export async function fetchMaintenanceStatus(): Promise<MaintenanceStatus> {
  const { data, error } = await supabase.rpc("get_maintenance_status");
  if (error) return logAndThrow("rpc get_maintenance_status", error);
  return normalizeMaintenanceStatus(data);
}

export interface MaintenanceUpdate {
  enabled: boolean;
  block_writes: boolean;
  scope: MaintenanceScope[];
  message_fr: string | null;
  message_ar: string | null;
  starts_at: string | null;
  ends_at: string | null;
}

export async function updateMaintenance(
  payload: MaintenanceUpdate
): Promise<MaintenanceStatus> {
  const { data, error } = await supabase.rpc("set_system_maintenance", {
    p_enabled: payload.enabled,
    p_block_writes: payload.block_writes,
    p_scope: payload.scope,
    p_message_fr: payload.message_fr,
    p_message_ar: payload.message_ar,
    p_starts_at: payload.starts_at,
    p_ends_at: payload.ends_at,
  });
  if (error) return logAndThrow("rpc set_system_maintenance", error);
  return normalizeMaintenanceStatus(data);
}
